export const APP_TITLE = 'Festayre';
export const PAGE_TITLE_NOT_FOUND = 'Lost in space';
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 Mo for upload
export const TERMS_OF_SERVICE_UPDATE_DATE = '2025/04/01';
export const PRIVACY_POLICY_UPDATE_DATE = '2025/04/01';
// NAVIGATION
export const NAVIGATION = {
  Guest: [
    '/spots',
    // '/events',  // tmp hide
    '/search',
    '/register/spot',
    '/terms-of-service',
    '/privacy-policy',
    '/oauth/success',
  ],
  Consumer: [
    '/spots',
    // '/events', // tmp hide
    '/search',
    '/me/calendar',
    '/terms-of-service',
    '/privacy-policy',
    '/oauth/success',
  ],
  Spot: ['/me/dashboard/preview', '/me/calendar/booking', '/me/calendar/event', '/oauth/success'],
  Support: [
    '/support/dashboard',
    '/support/users',
    '/support/accounts',
    '/support/events',
    '/support/reports',
    '/terms-of-service',
    '/privacy-policy',
    '/oauth/success',
  ],
  Maker: [],
  Organizer: [],
};
export const NAVIGATION_MAP = {
  Guest: {
    spots: '/spots',
    events: '/events', // tmp hide
    search: '/search',
    'terms-of-service': '/terms-of-service',
    'privacy-policy': '/privacy-policy',
    'oauth/success': '/oauth/success',
  },
  Consumer: {
    spots: '/spots',
    events: '/events', // tmp hide
    search: '/search',
    me: '/me',
    calendar: '/me/calendar',
    'terms-of-service': '/terms-of-service',
    'privacy-policy': '/privacy-policy',
    'oauth/success': '/oauth/success',
  },
  Spot: {
    dashboard: '/me/dashboard/preview',
    booking: '/me/calendar/booking',
    event: '/me/calendar/event',
    me: '/me',
    'oauth/success': '/oauth/success',
  },
  Support: {
    dashboard: '/support/dashboard',
    users: '/support/users',
    accounts: '/support/accounts',
    events: '/support/events',
    reports: '/support/reports',
    'terms-of-service': '/terms-of-service',
    'privacy-policy': '/privacy-policy',
    'oauth/success': '/oauth/success',
  },
  Maker: {},
  Organizer: {},
};
export const EVENTS_SPOTS_CACHE_TTL = 1000 * 60 * 5;
export const EVENTS_LAST_CALL = 'EVENTS_LAST_CALL';
export const SPOTS_LAST_CALL = 'SPOTS_LAST_CALL';
export const CALENDAR_LAST_KNOWN_DATE_KEY = 'CALENDAR_LAST_KNOWN_DATE';
